import { ERole } from "../../shared/enums/user/ERole";
import { adminRoutes } from "./roles/adminRoutes";

export const routeList = [
  {
    role: ERole.ADMIN,
    routes: adminRoutes,
  },
];
